/**
 * Viewport scaling is disabled. CSS zoom and transform-scale both break
 * fixed overlays (Post shift) and 100vh column heights.
 * This still clears any leftover zoom/transform from earlier sessions.
 */

export const initViewportScale = (): void => {
  const html = document.documentElement;
  const body = document.body;
  const app = document.getElementById("root");

  html.style.removeProperty("zoom");
  html.style.removeProperty("--ui-scale");
  delete html.dataset.uiScale;

  if (body) {
    body.style.removeProperty("zoom");
  }

  if (app) {
    app.style.removeProperty("zoom");
    app.style.removeProperty("transform");
    app.style.removeProperty("transform-origin");
    app.style.width = "100%";
    app.style.height = "";
  }
};
